import { Injectable } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Observable, from, of } from 'rxjs';
import { mergeMap, reduce, tap, catchError } from 'rxjs/operators';
import { RestMaintenanceService } from 'src/app/service/rest/maintenance/rest-maintenance.service';
import { Maintenance } from './maintenance.model';

@Injectable()
export class MaintenanceRepositoryService {

  private _maintenances: Maintenance[] = [];
  private _dataSourceMaintenances = new MatTableDataSource<Maintenance>();

  constructor(private maintenanceRest: RestMaintenanceService) { }

  public get maintenances(): Maintenance[] {
    return this._maintenances;
  }
  public set maintenances(value: Maintenance[]) {
    this._maintenances = value;
  }

  public get dataSourceMaintenances() {
    return this._dataSourceMaintenances;
  }
  public set dataSourceMaintenances(value) {
    this._dataSourceMaintenances = value;
  }

  getMaintenances(articleId : number, languageId : string) : Observable<Maintenance[]> {
    return this.maintenanceRest.getMaintenancesByArticleIdAndLanguageId(articleId, languageId);
  }

  getMaintenancesFromArticles(articleIds: number[], languageId: string) : Observable<Maintenance[]> {
    return from(articleIds).pipe(
      mergeMap(articleId =>
        this.maintenanceRest.getMaintenancesByArticleIdAndLanguageId(articleId, languageId).pipe(
          tap({
            error: err => console.error(`Error for articleId ${articleId}:`, err) // Exception logs
          }),
          catchError(() => of([])) // Ignore exceptions and return an empty array
        )
      ),
      reduce((acc, val) => [...acc, ...val], []) // Merge results into unique array
    );
  }

  getMaintenancesByArticleId(articleId: number) : Maintenance[]{
    return this.maintenances.filter((maintenance: Maintenance) => maintenance.articleId == articleId);
  }

}
